export default __webpack_public_path__ + "static/media/setting.94178ddd.svg";